import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import {
  getParent,
  hideElement,
  displayElement,
  enableElement,
  disableElement
} from '@fretadao/f-js-dom';

application.register(
  'vehicle-schedules-rebuild',
  class extends Controller {
    static targets = ['vehicleField', 'ingoingLinesField', 'outgoingLinesField', 'scheduleTypeField', 'scheduledForField'];
    static values = { vehicleLinesEndpoint: String };

    connect() {
      this._setEventForVehicleField();
      this._setEventForScheduleTypeField();
    }

    _setEventForVehicleField() {
      $(this.vehicleFieldTarget).on('select2:select', e => this._setLinesForVehicle(e.target.value));
    }

    _setLinesForVehicle(vehicleId) {
      this._getLines(vehicleId, (data) => {
        const ingoingLineIds = data?.ingoing?.map(line => line.id);
        this._setLinesOnField(this.ingoingLinesFieldTarget, ingoingLineIds);

        const outgoingLineIds = data?.outgoing?.map(line => line.id);
        this._setLinesOnField(this.outgoingLinesFieldTarget, outgoingLineIds);
      });
    }

    _setLinesOnField(field, lineIds) {
      $(field).val(lineIds).trigger('change');
    }

    _getLines(vehicleId, callback) {
      return fetch(this.vehicleLinesEndpointValue.replace('VEHICLE_ID', vehicleId))
        .then(response => response.json())
        .then(data => { callback(data) })
        .catch(error => {
          console.error(error);
          alert('Estamos com problemas filtrar as linhas. Tente novamente mais tarde.');
        });
    }

    _setEventForScheduleTypeField() {
      $(this.scheduleTypeFieldTarget).on('select2:select', (e) => {
        const scheduledFor = getParent(this.scheduledForFieldTarget);
        if(e.target.value === 'provisional') {
          displayElement(scheduledFor);
          enableElement(this.scheduledForFieldTarget);
        }
        else {
          hideElement(scheduledFor);
          disableElement(this.scheduledForFieldTarget);
        }
      });
      $(this.scheduleTypeFieldTarget).on('select2:clear', (e) => {
        const scheduledFor = getParent(this.scheduledForFieldTarget);
        hideElement(scheduledFor);
        disableElement(this.scheduledForFieldTarget);
      });
    }
  }
)
